import { render } from "./MessagingView.vue?vue&type=template&id=1cf9929d&scoped=true"
import script from "./MessagingView.vue?vue&type=script&lang=js"
export * from "./MessagingView.vue?vue&type=script&lang=js"

import "./MessagingView.vue?vue&type=style&index=0&id=1cf9929d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf9929d"]])

export default __exports__